import { render, staticRenderFns } from "./BarangayLeadersList.vue?vue&type=template&id=036a1c35"
import script from "./BarangayLeadersList.vue?vue&type=script&lang=js"
export * from "./BarangayLeadersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports